const bloodtypes = [
    { "value": "", "name": ""},
    { "value": "A", "name": "A型"},
    { "value": "B", "name": "B型"},
    { "value": "AB", "name": "AB型"},
    { "value": "O", "name": "O型"},
    { "value": "unknown", "name": "不明"},
];
export default bloodtypes;